var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("height: " + _vm.heightScrollbar + "px; width: " + _vm.widthScrollbar + "px; overflow: auto")),attrs:{"id":"main-element"}},[_c('router-view'),_c('Spinner',{attrs:{"loading":_vm.isLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }